import { FC, memo, useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { Badge, Col, Empty, Row, Space, Typography } from 'antd';
// import { Line, Pie } from '@ant-design/charts';
import { useTranslation } from 'react-i18next';
import { DoctorAppointmentStatistics } from 'gql/statistics/__generated__/DoctorAppointmentStatistics';
import { GET_DOCTOR_APPOINTMENT_STATISTICS } from 'gql/statistics/queries';

import CountCard from '../CountCard';
import { Loading } from 'components/ui';

const { Title } = Typography;

const Statistics: FC = () => {
  const { t } = useTranslation();
  const { data, loading } = useQuery<DoctorAppointmentStatistics>(
    GET_DOCTOR_APPOINTMENT_STATISTICS,
    {
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first'
    }
  );

  const result = data?.doctorAppointmentStatistics?.data;
  const patientsCount = useMemo(
    () =>
      Number(result?.gender?.Female?.count || 0) +
      Number(result?.gender?.Male?.count || 0),
    [result?.gender?.Female?.count, result?.gender?.Male?.count]
  );

  if (loading) {
    return <Loading />;
  }

  return (
    <div>
      <Title style={{ display: 'inline-block' }} level={4}>
        {t('dashboard.statistics')}
      </Title>
      {result?.appointmentsCount ? (
        <Row gutter={[32, 32]} align="stretch" wrap>
          <Col xs={24} md={12}>
            <CountCard
              title={t('dashboard.appointments')}
              count={result.appointmentsCount || 0}
              to="/appointments"
            >
              <Space>
                <Badge color="#88B5FF" text="20 (MedicusUnion)" />
                <Badge color="#35B678" text="12 (Personal)" />
              </Space>
            </CountCard>
          </Col>
          <Col xs={24} md={12}>
            <CountCard
              title={t('dashboard.patients')}
              count={patientsCount}
              to="/patients"
            >
              <Space>
                <Badge color="#88B5FF" text="20 (MedicusUnion)" />
                <Badge color="#35B678" text="12 (Personal)" />
              </Space>
            </CountCard>
          </Col>
        </Row>
      ) : (
        <Empty />
      )}
    </div>
  );
};

export default memo(Statistics);
